const AverageActivation = () => {
  return (
    <div
      data-component="CMSAverageActivation"
      className="flex gap-[10px] md:gap-[6.2] items-center text-sm md:text-xs lg:text-base font-nunito700"
    >
      <p className="hidden md:inline average-activation-text">Avg activation</p>
      <div className="py-1 px-2 rounded-3xl bg-deep-teal-400 average-activation-chip">
        03min 24sec
      </div>
    </div>
  );
};
export { AverageActivation };
